import Ansi from "@cocalc/ansi-to-react";
import type { FC } from "react";
import { useLoaderData } from "react-router-dom";

const ViewRoute: FC = () => {
  const plaintext = useLoaderData() as string;

  return (
    <div className="flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4">
      <pre className="bg-gray-950 rounded-sm text-sm font-mono p-4 overflow-x-scroll">
        <Ansi>{plaintext}</Ansi>
      </pre>
    </div>
  );
};

export default ViewRoute;
